export default __webpack_public_path__ + "static/media/skydream-logo.ef442220.png";